import { Application } from '@hotwired/stimulus'
import { definitionsFromContext } from '@hotwired/stimulus-webpack-helpers'
import * as Sentry from '@sentry/browser'
import { getSentryTrafficTag, flushDeferredEvalErrors } from './helpers/sentryObservability'

const isLocal = window.location.hostname.startsWith('localhost')

//* Sentry.init runs on every embed; only trace/replay sampling is gated by ?savvy_editing.
const urlParams = new URLSearchParams(window.location.search)
const isEditingMode = urlParams.has('savvy_editing')

//* Sample rate: 1.0 for preview mode, 0 for customer embeddables
const tracesSampleRate = isEditingMode ? 1.0 : 0
const replaysSessionSampleRate = isEditingMode ? 0.1 : 0
const replaysOnErrorSampleRate = isEditingMode ? 1.0 : 0

const sentryTrafficTag = getSentryTrafficTag({
  hostname: window.location.hostname,
  pathname: window.location.pathname,
})

Sentry.init({
  dsn: process.env.SENTRY_DSN || '',
  environment: process.env.SENTRY_ENV || 'dev',
  release: process.env.SENTRY_RELEASE || '',
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  tracesSampleRate,
  replaysSessionSampleRate,
  replaysOnErrorSampleRate,
  enableLogs: true,
  //* Drop browser error events; bootstrap logs use enableLogs + logSentryStep, not beforeSend
  beforeSend: () => null,
})

Sentry.getCurrentScope().setTag('traffic', sentryTrafficTag)

//* renderer_eval_js_v3 may have deferred logs before this bundle boots Sentry, so drain the queue now.
flushDeferredEvalErrors({ flush_source: 'bundle_boot' })

//* Expose the flush so eval v3 can drain immediately when it runs *after* the bundle (SSR race).
//* Also flush on 'load' for the case where eval ran before boot and queueing landed between boots.
window.__EMBEDDABLES_FLUSH_EVAL_ERRORS__ = flushDeferredEvalErrors
window.addEventListener('load', () => flushDeferredEvalErrors({ flush_source: 'window_load' }))

const application = Application.start()
// eslint-disable-next-line no-undef
const context = require.context('./controllers', true, /\.(js|ts)$/)

application.debug = isLocal && new URLSearchParams(window.location.search).has('savvy_debug')

application.load(definitionsFromContext(context))
;(window as any).StimulusApp = application
